import MUIFormControlLabel from '@mui/material/FormControlLabel';
import MUIFormControl from "@mui/material/FormControl";
import MUIRadioGroup from "@mui/material/RadioGroup";
import MUIRadio from "@mui/material/Radio";
import InfoItem from '../InfoItem';
import ReportSetting from "../ReportSetting";
import MainContext from "../../Context/MainContext/MainContext";

export default class ReportSettingAccountStatus extends ReportSetting {
    static contextType = MainContext; // For legacy class components

    /**
     * Renders target account checkbox.
     */
    renderAccountStatusRadio() {
        return (
            <MUIFormControl>
                <MUIRadioGroup
                    row
                    value={this.state.settings.status || "all"}
                    defaultChecked={"all"}
                    onChange={(e) => {
                        this.handleSettingChange("status", e.target.value)
                    }}>
                    <MUIFormControlLabel
                        value={"all"}
                        control={<MUIRadio size="small" />}
                        label="All"
                    />
                    <MUIFormControlLabel
                        value={"top"}
                        control={<MUIRadio size="small" />}
                        label="Top Accounts"
                    />
                    <MUIFormControlLabel
                        value={"target"}
                        control={<MUIRadio size="small" />}
                        label="Target Accounts"
                    />
                </MUIRadioGroup>
            </MUIFormControl>
        );
    }

    renderContent() {
        return (
            <>
                {this.renderAccountStatusRadio()}
            </>
        );
    }

    renderReadOnly() {
        const statusValue = this.state.settings?.status;
        const displayValue = (statusValue?.charAt(0).toUpperCase() + statusValue?.slice(1)) || "All"
        return <InfoItem label="Status" value={displayValue} />;
    }
}